<template>
    <div>
        <!-- Header -->
        <navbar :logo="logo" :auth-user="authUser" class="position-absolute top-0 start-0 w-100" style="z-index: 1000;"></navbar>

        <!-- Hero Section -->
        <hero-section :parent-categories="parentCategories" :hero-slider="heroSlider"></hero-section>

        <div class="home-content-wrapper">
            <!-- Categories -->
            <categories-section :categories="subCategories"></categories-section>

            <!-- Best Selling -->
            <best-selling-section 
                :products="displayedProducts" 
                :activeTab="activeTab"
                @tab-change="setActiveTab"
                @add-to-cart="addToCart">
            </best-selling-section>

            <!-- Promo Section -->
            <promo-section :offer="promoOffer"></promo-section>

            <!-- Benefits Section -->
            <!-- <benefits-section></benefits-section> -->

            <!-- Weekly Deals -->
            <!-- <weekly-deals-section></weekly-deals-section> -->

            <!-- Blogs -->
            <blogs-section :blogs="recentBlogs"></blogs-section>

            <!-- Footer -->
             <footer-section :logo="logo"></footer-section>
        </div>
    </div>
</template>

<script>
import HeroSection from './home_sections/HeroSection.vue';
import CategoriesSection from './home_sections/CategoriesSection.vue';
import BestSellingSection from './home_sections/BestSellingSection.vue';
import PromoSection from './home_sections/PromoSection.vue';
import BenefitsSection from './home_sections/BenefitsSection.vue';
import WeeklyDealsSection from './home_sections/WeeklyDealsSection.vue';
import BlogsSection from './home_sections/BlogsSection.vue';
import FooterSection from './home_sections/FooterSection.vue';

export default {
    props: ['authUser'],
    components: {
        HeroSection,
        CategoriesSection,
        BestSellingSection,
        PromoSection,
        BenefitsSection,
        WeeklyDealsSection,
        BlogsSection,
        FooterSection
    },
    data() {
        return {
            logo: null,
            bestSellingProducts: [],
            featuredCategories: [],
            subCategories: [],
            parentCategories: [],
            heroSlider: null,
            promoOffer: null,
            recentBlogs: [],
            newArrivals: [],
            topRated: [],
            loading: true,
            activeTab: 'best_sellers',
        }
    },
    computed: {
        displayedProducts() {
            if (this.activeTab === 'new_arrivals') {
                return this.newArrivals;
            } else if (this.activeTab === 'top_rated') {
                return this.topRated;
            } else if (this.activeTab === 'best_sellers') {
                return this.bestSellingProducts;
            } else {
                return [
                    ...this.newArrivals, 
                    ...this.bestSellingProducts,
                    ...this.topRated
                ].filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i).slice(0, 8);
            }
        }
    },
    mounted() {
        this.fetchHomeData();
    },
    methods: {
        setActiveTab(tab) {
            this.activeTab = tab;
        },
        async fetchHomeData() {
            try {
                const response = await axios.get('/customer/home-data');
                this.bestSellingProducts = response.data.bestSellingProducts;
                this.featuredCategories = response.data.featuredCategories;
                this.recentBlogs = response.data.recentBlogs;
                this.newArrivals = response.data.newArrivals;
                this.topRated = response.data.topRated;
                this.topRated = response.data.topRated;
                this.logo = response.data.logo;
                this.parentCategories = response.data.parentCategories;
                this.heroSlider = response.data.heroSlider;
                this.subCategories = response.data.subCategories;
                this.promoOffer = response.data.promoOffer;
                this.loading = false;
            } catch (error) {
                console.error('Error fetching home data:', error);
                this.loading = false;
            }
        },
        addToCart(product) {
            if (!this.authUser) {
                // Redirect to login or show modal
                window.location.href = '/customer/login';
                return;
            }
            
            axios.post('/api/frontend/cart/add', {
                product_id: product.id,
                quantity: 1,
                price: product.price 
            })
            .then(response => {
                const cart = response.data.data;
                let count = 0;
                if(cart && cart.cart_items) {
                     count = cart.cart_items.length;
                }
                window.Bus.$emit('cart-updated', count);
                
                this.$swal.fire({
                    icon: 'success',
                    title: 'Added to Cart!',
                    text: 'Product has been added to your cart.',
                    timer: 2000,
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-end'
                });
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                if (error.response && error.response.status === 401) {
                     window.location.href = '/customer/login';
                }
            });
        }
    }
}
</script>

<style scoped>
.home-content-wrapper {
    position: relative;
    /* padding-bottom: 2rem; Optional: if needed for spacing */
}

.home-content-wrapper::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('/images/background.png');
    background-repeat: repeat;
    opacity: 0.15;
    z-index: -1;
    pointer-events: none;
}
</style>
